import { useState } from 'react'

import { Box, Icon, Tabs, Text, Touchable } from '@factorialco/deprecated-design-system'
import { BudgetMovementsDatatableQuery } from 'generated/resources/datatable.graphql'
import { BudgetMovementFragment } from 'generated/resources/graphql'

import { useDataTable } from 'modules/core/components/DataTable'
import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import InfoTab from './InfoTab'

interface Props {
  movementId: string
  onClose: () => void
}

const TABS = {
  INFO: 'info',
}

const MovementDetail = ({ movementId, onClose }: Props) => {
  const [tab, setTab] = useState(TABS.INFO)

  const { data } = useDataTable<BudgetMovementsDatatableQuery, BudgetMovementFragment>()

  const [index, setIndex] = useState(data.findIndex(({ id }) => id === movementId))

  const movement = data[index]

  const showPrevious = index > 0
  const showNext = index < data.length - 1

  const navigatePrevious = () => {
    setIndex(index - 1)
  }
  const navigateNext = () => {
    setIndex(index + 1)
  }

  return (
    <Sidepanel
      open
      width="wide"
      closeLabel={i18n.t('common.close')}
      onClose={onClose}
      title={
        <Box flexDirection="row" justifyContent="center" alignItems="center" flexGrow>
          {showPrevious && (
            <Touchable onClick={navigatePrevious}>
              <Icon.Small icon="chevron-left" />
            </Touchable>
          )}

          <Box paddingX="s24">
            <Text.Normal weight="semibold">
              {i18n.t('budgets.detail.tabs.spendings.sidepanel.title')}
            </Text.Normal>
          </Box>

          {showNext && (
            <Touchable onClick={navigateNext}>
              <Icon.Small icon="chevron-right" />
            </Touchable>
          )}
        </Box>
      }
    >
      <Tabs currentId={tab} onTabClicked={(tabId) => setTab(tabId)}>
        <Tabs.Tab id={TABS.INFO} label={i18n.t('budgets.detail.tabs.spendings.sidepanel.title')}>
          {movement && <InfoTab movement={movement} />}
        </Tabs.Tab>
      </Tabs>
    </Sidepanel>
  )
}
export default MovementDetail
